/** ファネルステップイベント（router afterEachで自動発火） */
export const FUNNEL_EVENTS = {
    GUIDE_VIEW: 'funnel_guide_view',
    INPUT_VIEW: 'funnel_input_view',
    CONFIRMATION_VIEW: 'funnel_confirmation_view',
    COMPLETE_VIEW: 'funnel_complete_view',
    CONSENT_VIEW: 'traveler_consent_view',
    HANDOVER_VIEW: 'traveler_handover_view',
} as const;

/** ユーザーアクションイベント（composable内で発火） */
export const ACTION_EVENTS = {
    GUIDE_SUBMIT_NEW: 'guide_submit_new_application',
    GUIDE_SUBMIT_EXISTING: 'guide_submit_existing_application',
    INPUT_SUBMIT: 'input_submit_to_confirmation',
    CONFIRMATION_SUBMIT: 'confirmation_submit_application',
    APPLICATION_COMPLETE: 'application_complete',
    CONSENT_SUBMIT: 'consent_submit_signature',
    HANDOVER_SUBMIT: 'handover_submit_signature',
} as const;
